import * as ACTIONS from "@iso/redux/filtersCategories/actionTypes";

const initialState = {
  filtersCategories: {
    list: [],
    total: 0,
  },
};

function filtersCategoriesReducer(state = initialState, action) {
  const { payload, type } = action;

  switch (type) {
    case ACTIONS.GET_FILTERS_CATEGORIES_SUCCESS: {
      return {
        ...state,
        ...{ filtersCategories: payload },
      };
    }

    default:
      return state;
  }
}

export default filtersCategoriesReducer;
